import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import icons from "../../../Data/icons";
import StoreIcon from "../../../Components/Common/svg/storeicon";
import UserStoreStatusCard from "../../../Components/users/userStoreStatusCard";

const Userprofile = () => {
  const { t } = useTranslation();

  const user = JSON.parse(localStorage.getItem("user")) || {};
  const role = JSON.parse(localStorage.getItem("role"));
  const isVendor = JSON.parse(localStorage.getItem("is_vendor")) || null;
  const vendorStore = user?.store || null;
  const selectedStore = JSON.parse(localStorage.getItem("selectedStore"));
  const navigate = useNavigate();

  return (
    <li className="cursor d-flex gap-3 align-items-center">
      {isVendor && vendorStore && (
        <div className="d-flex align-items-center gap-2 ">
          <div className="text-center">
            <div
              className="fw-bold"
              onClick={
                selectedStore?.name
                  ? () =>
                      navigate(`${process.env.PUBLIC_URL}/vendor/choose-store`)
                  : undefined
              }
              style={
                !selectedStore?.name
                  ? { cursor: "pointer", textDecoration: "underline" }
                  : {}
              }
            >
              {selectedStore?.name || vendorStore?.name}
            </div>
            <div className="text-muted small">
              {selectedStore?.section?.type}
            </div>
          </div>
          <StoreIcon />
        </div>
      )}
      {isVendor && <UserStoreStatusCard storeId={vendorStore?.id} />}

      <div className="text-center">
        <div> {user?.name || user?.full_name} </div>
        <div>{role || user?.role}</div>
      </div>
      <div
        className="bg-primary rounded-circle "
        style={{ width: "36px", height: "36px" }}
      ></div>
    </li>
  );
};

export default Userprofile;
